import cx from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';
import { ICCard, ICDoc, ICEuro, ICHome, ICTrax, ICWalletInspect } from '../../../assets';
import { Spacer } from '../../atoms';

export default function SidebarItem({active, title, onClick, type }) {
  const classNames = cx({
    'sideBarItem': true,
    'active': active
  })
  const Icon = () => {
    if (title === "Home") {
      return <img src={ICHome} alt="" className="icon" />;
    }
    if (title === "Fast Trax") {
      return <img src={ICTrax} alt="" className="icon" />;

    }
    if (title === "Follow Whale") {
      return <img src={ICEuro} alt="" className="icon" />;

    }
    if (title === "More to come...") {
      return <img src={ICCard} alt="" className="icon" />;

    }
    if (title === "Documentation") {
      return <img src={ICDoc} alt="" className="icon" />;
    }
    if (title === "Token Inspector") {
      return <img src={ICWalletInspect} alt="" className="icon" />;
    }
    if (title === "Deficandy Bot") {
      return <div className="me-5"></div>
    }
    return null;
  }

  if (type === "Doc") {
    return (
      <div className="menuDoc">
        <div className={classNames}>
          <Icon />
          <Spacer w={10} />
          <div className="label">
            <span>{title}</span>
          </div>
          <Spacer w={20} />
        </div>
        <div className="items">
          <div className="item">
            <div className="dot" style={{ backgroundColor:'#F8D65E' }}></div>
            <Link to="/tokenomic">Tocenomics</Link>
          </div>
          <div className="item">
            <div className="dot" style={{ backgroundColor:'#FF4B4B' }}></div>
            <Link to="/tier">Tier System</Link>
          </div>
          <div className="item">
            <div className="dot" style={{ backgroundColor:'#5458F7' }}></div>
            <Link to="/roadmap">Roadmap</Link>
          </div>
          <div className="item">
            <div className="dot" style={{ backgroundColor:'#F8D65E' }}></div>
            <a target="_blank" rel="noreferrer" href="https://github.com/">Open Github Repo</a>
          </div>
          <div className="item">
            <div className="dot" style={{ backgroundColor:'#FF4B4B' }}></div>
            <a target="_blank" rel="noreferrer" href="https://medium.com/">Medium</a>
            <p></p>
          </div>
          <div className="item">
            <div className="dot" style={{ backgroundColor:'#62D2FF' }}></div>
            <a target="_blank" rel="noreferrer" href="https://twitter.com/">Twitter</a>
          </div>
        </div>
      </div>
    )
  }
  return (
    <div className={classNames} onClick={onClick}>
      <Spacer w={50} />
      <Icon />
      <Spacer w={10} />
      <div className="label">
        <span>{title}</span>
      </div>
      <Spacer w={20} />
    </div>
  )
}
